module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/bradley-university-692e4f8a804351b00585d2fc4ea803e0.jpg";